import React from 'react';
import PropTypes from 'prop-types';
import IconRevenue from 'assets/inviteABite/iab-revenue.svg';
import {
  IABMetricCard,
  IABMetricContentRow,
  IABMetricIcon,
  IABMetricLabel,
  IABMetricSubtext,
  IABMetricTextBlock,
  IABMetricTitleRow,
  IABMetricValue
} from 'routes/App/inviteABite/ActiveState/styles';

const formatCurrency = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(Number(value || 0));

const RevenueCard = ({revenue}) => (
  <IABMetricCard>
    <IABMetricTitleRow>
      <IABMetricIcon src={IconRevenue} alt='' />
      <IABMetricTextBlock>
        <IABMetricLabel>Revenue from referrals</IABMetricLabel>
      </IABMetricTextBlock>
    </IABMetricTitleRow>
    <IABMetricContentRow>
      <IABMetricValue>{formatCurrency(revenue)}</IABMetricValue>
      <IABMetricSubtext>Total spend by referred customers</IABMetricSubtext>
    </IABMetricContentRow>
  </IABMetricCard>
);

RevenueCard.propTypes = {
  revenue: PropTypes.number
};

RevenueCard.defaultProps = {
  revenue: 0
};

export default RevenueCard;
